import { createContext } from "react";
import useLocalStorageState from 'use-local-storage-state'


export const defaultValues = {
  User: {
    ID: undefined,
    use_username: undefined,
    use_calendar_start: undefined,
    use_language: undefined,
    use_calendar_end: undefined,
    use_calendar_hour_format: undefined,
    use_round_corner: undefined,
    use_palette_ID: undefined,
    use_gapi_logged: undefined,
    use_palette_name: undefined,
    use_last_read: undefined,
    Palettes: [],
    Groups: [],
  },
  Shop: {
    ID:  undefined,
    sho_name: undefined,
    sho_message: undefined,
    sho_language: undefined,
    show_message_time: undefined,
    show_sms_sender: undefined,
    mailer: {}
  },
  Agency: {
    ID: undefined,
    age_name: undefined,
    age_email: undefined,
    age_number: undefined,
    age_max_shops: undefined,
    age_max_users: undefined,
    age_enable_stats: undefined,
    age_enable_sms: undefined,
    age_enable_email: undefined,
    age_enable_drive_api: undefined,
    Groups: [],
  },
  Theme: {
    name: 'light',
    palette: [
      "#ffffff", //sfondo calendario
      "#dddddd",  //sfondo tutto
      "#ffffff", //sfondo sidebar
      "#000000", //testo chiaro
      "#ffffff", //testo scuro
      "#00000055"  //box shadow
    ],
    text_font: "tw_cen_mtbold, serif",
    title_font: "tw_cen_mtbold, serif",
    text_size: 14,
  },
  Alert:{
    show: false,
    visible: false,
    showTime: 1000,
    title: '',
    color: '#12ff39',
    textColor: '#0b801f',
    message: '',
  },
  Reloads:{
    events:false,
    user: false,
    agency: false,
    categories: false,
    customers: false,
    customerRequests: false
  },
  PreventReloads:{
    events:false,
    user: false,
    agency: false,
    categories: false,
    customers: false,
  },
  // backendUrl: 'http://localhost:3001',
  // frontendUrl: 'http://localhost:3000',
  backendUrl: 'https://agenda.nacplan.ch',
  frontendUrl: 'https://agenda.nacplan.ch',
  socket: undefined,
  categories: [],
  customers: [],
  customerRequests: [],
  shops: [],
  openings: [],
  selectedShop: {},
  loaded: false,
  EventsLoaded: false,
  showUsersList: false,
}


const GlobalContext = createContext(
  { set: undefined, get: undefined }
);

export default GlobalContext 
